<template>
  <DrField :for="$attrs.id" :label="$attrs['data-label']" :error="$attrs.error" :formShake="formShake">
    <div class="relative">
      <select
        :class="{ placeholder: placeholder && !value }"
        :value="value"
        v-bind="$attrs"
        @change="emitEvent($event.target.value)"
      >
        <option v-if="placeholder" value disabled selected class="placeholder">{{ placeholder }}</option>
        <slot />
      </select>
      <DrIcon svg="angle-down" class="pointer-events-none text-grey-575 absolute top-center right-0 mr-2" />
    </div>
    <div class="help">
      <slot name="help"/>
    </div>
  </DrField>
</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    /** @ignore */
    value: {
      type: [String, Number],
      default: '',
    },
    formShake: {
      type: Boolean,
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
  },
  methods: {
    /**
      * @todo https://github.com/mannum/vue-quote-frontend/pull/91#pullrequestreview-210606559
      * Hmm, surprised by this. As is a base component, am keen to keep as a transparent wrapper if possible:
      * https://vuejs.org/v2/guide/components-custom-events.html#Binding-Native-Events-to-Components

      * Is it possible to double check details in the Vue docs to see if can work, or i'll try come back to this later.
     */
    emitEvent(value) {
      this.$emit('input', value)
    },
  },
}
</script>

<style>
.placeholder {
  @apply text-grey-550 !important;
}
</style>

<docs>
This is a transparent component of `<select>`

```vue
<DrSelect>
  <option value="something">Something</option>
</DrSelect>
```
</docs>
